export default "__VITE_ASSET__Cs5WTu5J__"